import Cookies from 'js-cookie'

const getDefaultState = () => {
  return {
    HasTabbar: Cookies.get('HasTabbar') || false,
    NoticeImg: Cookies.get('NoticeImg') || true
  }
}

const state = getDefaultState()

const mutations = {
  SET_HASTABBAR: (state, payload) => {
    state.HasTabbar = payload
    Cookies.set('HasTabbar', payload)
  },
  SET_NOTICE: (state, payload) => {
    state.NoticeImg = payload
    Cookies.set('NoticeImg', payload)
  }
}

const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
